import { Component } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {CompoMovimentazione} from "../stato-movimentazioni.component";
import {MessageService, SelectItem} from "primeng/api";
import {ModelloDispositivoApiDescriptor, TipoMovimentazione} from "../../../../models/magazzino.model";

@Component({
  selector: 'app-inconsistency-report-dialog',
  templateUrl: './inconsistency-report-dialog.component.html',
  styleUrls: ['./inconsistency-report-dialog.component.scss']
})
export class InconsistencyReportDialogComponent {

	refMovimentazione: CompoMovimentazione;

	optionsMateriali: SelectItem<ModelloDispositivoApiDescriptor>[];

	edits_materiali: {
		modello:		ModelloDispositivoApiDescriptor,
		qt:				number;
	}[];
	active_materials: string[];
	currentOptionMateriali: ModelloDispositivoApiDescriptor;

	materialiById: {[key: string]: ModelloDispositivoApiDescriptor};
	previstiById: {[key: string]: number};

	hasValidForm: boolean;

	constructor(
		public dialogService: DialogService,
		public ref: DynamicDialogRef,
		public config: DynamicDialogConfig<{
			src: CompoMovimentazione,
			materiali: ModelloDispositivoApiDescriptor[],
			values?: {[key: string]: number}
		}>,
		private messages: MessageService
	) {

		this.refMovimentazione = this.config.data.src;
		this.previstiById = Object.fromEntries(this.config.data.src.materiali.map((item) => {
			return [item.id, item.qt];
		}));
		this.materialiById = Object.fromEntries(this.config.data.materiali.map((item) => { return [item.id, item]}));

		this.edits_materiali = Object.entries(config.data.values ?? {}).map((item) => {
			return {
				modello: this.materialiById[item[0]],
				qt: (this.previstiById[item[0]] ?? 0) + item[1]
			}
		});
		this.refreshAvailableMaterialsList();
		this.verifyForm();
	}

	removeFromMaterialsList (key: string) {
		const idx = this.edits_materiali.findIndex((item) => {
			return item.modello.id == key;
		});
		if (idx != -1) {
			this.edits_materiali.splice(idx, 1);
		}
		this.refreshAvailableMaterialsList();
		this.verifyForm();
	}

	addToMaterialsList () {
		this.edits_materiali.push({modello: this.currentOptionMateriali, qt: this.previstiById[this.currentOptionMateriali.id] ?? 0});
		this.currentOptionMateriali = null;
		this.refreshAvailableMaterialsList();
		this.verifyForm();
	}

	refreshAvailableMaterialsList () {
		const mov_materials = this.refMovimentazione.materiali.map((item) => {
			return item.id;
		});
		this.active_materials = this.edits_materiali.map((item) => { return item.modello.id});
		this.optionsMateriali = this.config.data.materiali.filter((item) => {
			return this.active_materials.indexOf(item.id) == -1 && mov_materials.indexOf(item.id) != -1;
		}).map((item) => {
			return { label: `${item.nmu}: ${item.descrizione}`, value: item }
		});
	}


	verifyForm () {
		this.hasValidForm = true;
	}

	onActivityCompleted (confirm: boolean) {
		const itemdiffs = Object.fromEntries(this.edits_materiali.map((item) => {
			return [item.modello.id, item.qt - (this.previstiById[item.modello.id] ?? 0)]
		}));
		this.ref.close(confirm ? itemdiffs : null);
	}

}
